/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unsafe-i18n-at-module-eval */
import I18n from 'I18n';
import { createContext } from 'react';

type I18nType = typeof I18n;

interface I18nInternalType extends I18nType {
  translations?: any;
  locale?: string;
  lang?: string;
  langEnabled?: boolean;
  publicPage?: boolean;
  manualLocale?: string;
  manualTimezone?: string;
  manualUserObjectTimezone?: string;
  fired: {
    ready?: boolean;
  };
  timezone?: string;
  userObjectTimezone?: string;
  Info: Promise<I18nType> & {
    resolve: (info: {
      locale: string;
      langEnabled?: boolean;
      timezone?: string;
      userObjectTimezone?: string;
    }) => void;
    reject: () => void;
  };
  debugLog(...data: any[]): void;
  hasHadLoadingFailure?: boolean;
}

const I18nInternal = I18n as I18nInternalType;
export const I18nHMRContext = createContext({});

export { I18nInternal };
